export const API_CONFIG = {
    // BASE_URL: 'https://dsc-backend-production-8f65.up.railway.app/api',
    // UPLOADS_URL: 'https://dsc-backend-production-8f65.up.railway.app/uploads'
     BASE_URL: 'https://api.dsconcept.in/api',
    UPLOADS_URL: 'https://api.dsconcept.in/uploads'
    // BASE_URL: 'http://localhost:5000/api',
    // UPLOADS_URL: 'http://localhost:5000/uploads'
  };